<p-dialog
  [header]="translatePrefix + 'CHANGE-PASSWORD' | translate"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: '480px' }"
  [(visible)]="isChangePassword"
	(onHide)="isChangePasswordChange.emit(false)"
  [focusOnShow]="false">
  <form class="flex flex-col gap-4" [formGroup]="changePasswordForm">
    <!-- HINT -->
    <div class="flex flex-col gap-2">
      <div>{{ translatePrefix + 'USE-A-PASSWORD' | translate }}</div>
      <!-- MINLENGTH -->
      <div
        class="h-4 flex items-center gap-1"
        [ngClass]="{
          'text-gray-600': !passwordControl.value,
          'text-green-600': passwordControl.dirty && passwordControl.value && !passwordControl.errors?.['passwordRules']?.['minLength'],
          'text-red-600': passwordControl.dirty && passwordControl.errors?.['passwordRules']?.['minLength']
        }">
        <i
          class="text-4"
          [ngClass]="{
            'icon-wl-minus': !passwordControl.value,
            'icon-wl-check': passwordControl.dirty && passwordControl.value && !passwordControl.errors?.['passwordRules']?.['minLength'],
            'icon-wl-close': passwordControl.dirty && passwordControl.errors?.['passwordRules']?.['minLength']
          }"></i>
        <span class="text-3">{{ translatePrefix + 'MINIMUM-CHARACTERS' | translate }}</span>
      </div>

      <!-- UPPERCASE -->
      <div
        class="h-4 flex items-center gap-1"
        [ngClass]="{
          'text-gray-600': !passwordControl.value,
          'text-green-600': passwordControl.dirty && passwordControl.value && !passwordControl.errors?.['passwordRules']?.['upperCase'],
          'text-red-600': passwordControl.dirty && passwordControl.errors?.['passwordRules']?.['upperCase']
        }">
        <i
          class="text-4"
          [ngClass]="{
            'icon-wl-minus': !passwordControl.value,
            'icon-wl-check': passwordControl.value && passwordControl.value && !passwordControl.errors?.['passwordRules']?.['upperCase'],
            'icon-wl-close': passwordControl.dirty && passwordControl.errors?.['passwordRules']?.['upperCase']
          }"></i>
        <span class="text-3">{{ translatePrefix + 'UPPERCASE-DESCRIPTION' | translate }}</span>
      </div>

      <!-- LOWERCASE -->
      <div
        class="h-4 flex items-center gap-1"
        [ngClass]="{
          'text-gray-600': !passwordControl.value,
          'text-green-600': passwordControl.dirty && passwordControl.value && !passwordControl.errors?.['passwordRules']?.['lowerCase'],
          'text-red-600': passwordControl.dirty && passwordControl.errors?.['passwordRules']?.['lowerCase']
        }">
        <i
          class="text-4"
          [ngClass]="{
            'icon-wl-minus': !passwordControl.value,
            'icon-wl-check': passwordControl.value && passwordControl.value && !passwordControl.errors?.['passwordRules']?.['lowerCase'],
            'icon-wl-close': passwordControl.dirty && passwordControl.errors?.['passwordRules']?.['lowerCase']
          }"></i>
        <span class="text-3">{{ translatePrefix + 'LOWERCASE-DESCRIPTION' | translate }}</span>
      </div>

      <!-- NUMBER -->
      <div
        class="h-4 flex items-center gap-1"
        [ngClass]="{
          'text-gray-600': !passwordControl.value,
          'text-green-600': passwordControl.dirty && passwordControl.value && !passwordControl.errors?.['passwordRules']?.['number'],
          'text-red-600': passwordControl.dirty && passwordControl.errors?.['passwordRules']?.['number']
        }">
        <i
          class="text-4"
          [ngClass]="{
            'icon-wl-minus': !passwordControl.value,
            'icon-wl-check': passwordControl.value && passwordControl.value && !passwordControl.errors?.['passwordRules']?.['number'],
            'icon-wl-close': passwordControl.dirty && passwordControl.errors?.['passwordRules']?.['number']
          }"></i>
        <span class="text-3">{{ translatePrefix + 'NUMBER-DESCRIPTION' | translate }}</span>
      </div>

      <!-- SPECIAL-CHAR -->
      <div
        class="h-4 flex items-center gap-1"
        [ngClass]="{
          'text-gray-600': !passwordControl.value,
          'text-green-600': passwordControl.dirty && passwordControl.value && !passwordControl.errors?.['passwordRules']?.['specialChar'],
          'text-red-600': passwordControl.dirty && passwordControl.errors?.['passwordRules']?.['specialChar']
        }">
        <i
          class="text-4"
          [ngClass]="{
            'icon-wl-minus': !passwordControl.value,
            'icon-wl-check': passwordControl.value && passwordControl.value && !passwordControl.errors?.['passwordRules']?.['specialChar'],
            'icon-wl-close': passwordControl.dirty && passwordControl.errors?.['passwordRules']?.['specialChar']
          }"></i>
        <span class="text-3">{{ translatePrefix + 'SPECIAL-CHAR' | translate }}</span>
      </div>
    </div>

    <!-- PASSWORD -->
    <app-form-control
      [label]="translatePrefix + 'CURRENT-PASSWORD' | translate"
      [control]="changePasswordForm.controls['currentPassword']"
      [required]="true"
      [floatLabel]="true">
      <p-password
        input
        [feedback]="false"
        styleClass="w-full"
        inputStyleClass="w-full"
        formControlName="currentPassword"
        autocomplete="on"
        [toggleMask]="true">
      </p-password>
    </app-form-control>

    <!-- NEW PASSWORD -->
    <app-form-control
      [label]="translatePrefix + 'NEW-PASSWORD' | translate"
      [control]="changePasswordForm.controls['password']"
      [required]="true"
      [floatLabel]="true">
      <p-password
        input
        [feedback]="false"
        styleClass="w-full"
        inputStyleClass="w-full"
        formControlName="password"
        autocomplete="on"
        [toggleMask]="true">
      </p-password>
    </app-form-control>

    <!-- CONFIRM NEW PASSWORD -->
    <app-form-control
      [label]="translatePrefix + 'CONFIRM-NEW-PASSWORD' | translate"
      [control]="changePasswordForm.controls['confirmPassword']"
      [required]="true"
      [floatLabel]="true">
      <p-password
        input
        [feedback]="false"
        styleClass="w-full"
        inputStyleClass="w-full"
        formControlName="confirmPassword"
        autocomplete="on"
        [toggleMask]="true">
      </p-password>
    </app-form-control>
  </form>

  <ng-template pTemplate="footer">
    <app-button
      [label]="'ACTION.CANCEL' | translate"
      variant="outline-secondary"
      size="xl"
      (onClick)="onCancelChangePassword()"></app-button>
    <app-button
      [label]="translatePrefix + 'CHANGE-PASSWORD' | translate"
      size="xl"
      [disabled]="isInvalidForm"
      (onClick)="onChangePassword()"></app-button>
  </ng-template>
</p-dialog>
